import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id  : 0,
        jira_host   : '',
        auth_key    : '',
        custom_name : '',
        create_time : 0,
        creator_id  : 0,
        is_disabled : false,
        fail_count  : 0
    },

    isDisabled: function() {
        return this.get('is_disabled');
    }
});